import React, { useEffect } from "react";
// import { Buffer } from "buffer";
import MenuImage from "../../components/MenuImage/MenuImage";
import "../IndexPage/IndexPage.css";

function WinesakeEditPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // const [loading, setLoading] = useState(true);
  // const [winesake, setSugested] = useState([]);

  // useEffect(() => {
  //   fetch("https://suntaka-backend-production.up.railway.app/api/winesakepdf")
  //     .then(async (response) => {
  //       if (response.ok) {
  //         // Si la respuesta es válida, intentar procesarla como JSON
  //         const { data: buffer } = await response.json();
  //         setSugested(buffer.data);
  //       } else {
  //         // Si la respuesta no es válida, intentar procesarla como un archivo binario
  //         const buffer = await response.arrayBuffer();
  //         setSugested(buffer);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setLoading(false);
  //     });
  // }, []);

  return (
    <div>
    <div className="sake-background"></div>
    <div className="card-container">
      <MenuImage
        width="1132" height="1600"
        className="pdf-sake"
        es="img/bodega_pagina_1.webp"
        en="img/bodega_pagina_1_en.webp"
        ja="img/bodega_pagina_1_ja.webp"
        alt="Bodega 1"
      />
      <MenuImage
        width="1132" height="1600"
        className="pdf-sake"
        es="img/bodega_pagina_2.webp"
        en="img/bodega_pagina_2_en.webp"
        ja="img/bodega_pagina_2_ja.webp"
        alt="Bodega 2"
      />
      </div>
      {/* {loading ? (
        <div className="loader">
          <span>Cargando...</span>
        </div>
      ) : (
        <div className="pdfReader" key={winesake.id}>
          <iframe
            title="Bodega"
            src={`data:application/pdf;base64,${Buffer.from(
              winesake,
              "binary"
            )}`}
            width="100%"
            height="200%"
            type="application/pdf"
            alt={`Imagen de la bodega`}
          />
          
        </div>
      )} */}
    </div>
  );
}

export default WinesakeEditPage;


